export const dmaMap: Record<string, string> = {
  "ABILENE - SWEETWATER": "Abilene - Sweetwater",
  "ALBANY - SCHENECTADY - TROY": "Albany - Schenectady - Troy",
  "ALBANY, GA": "Albany, GA",
  "ALBUQUERQUE - SANTA FE": "Albuquerque - Santa Fe",
  "ALEXANDRIA, LA": "Alexandria, LA",
  ALPENA: "Alpena",
  AMARILLO: "Amarillo",
  ANCHORAGE: "Anchorage",
  ATLANTA: "Atlanta",
  AUGUSTA: "Augusta",
  AUSTIN: "Austin",
  BAKERSFIELD: "Bakersfield",
  BALTIMORE: "Baltimore",
  BANGOR: "Bangor",
  "BATON ROUGE": "Baton Rouge",
  "BEAUMONT - PORT ARTHUR": "Beaumont - Port Arthur",
  "BEND, OR": "Bend, OR",
  BILLINGS: "Billings",
  "BILOXI - GULFPORT": "Biloxi - Gulfport",
  BINGHAMTON: "Binghamton",
  "BIRMINGHAM (ANN & TUSC)": "Birmingham (Anniston & Tuscaloosa)",
  "BLUEFIELD - BECKLEY - OAK HILL": "Bluefield - Beckley - Oak Hill",
  BOISE: "Boise",
  "BOSTON (MANCHESTER)": "Boston (Manchester)",
  "BOWLING GREEN": "Bowling Green",
  BUFFALO: "Buffalo",
  "BURLINGTON - PLATTSBURGH": "Burlington - Plattsburgh",
  "BUTTE - BOZEMAN": "Butte - Bozeman",
  "CASPER - RIVERTON": "Casper - Riverton",
  "CEDAR RAPIDS - WTRLO - IWC&DUB": "Cedar Rapids - Waterloo - Iowa City & Dubuque",
  "CHAMPAIGN & SPRNGFLD - DECATUR": "Champaign & Springfield - Decatur",
  "CHARLESTON - HUNTINGTON": "Charleston - Huntington",
  "CHARLESTON, SC": "Charleston, SC",
  CHARLOTTE: "Charlotte",
  CHARLOTTESVILLE: "Charlottesville",
  CHATTANOOGA: "Chattanooga",
  "CHEYENNE - SCOTTSBLUF": "Cheyenne - Scottsbluff",
  CHICAGO: "Chicago",
  "CHICO - REDDING": "Chico - Redding",
  CINCINNATI: "Cincinnati",
  "CLARKSBURG - WESTON": "Clarksburg - Weston",
  "CLEVELAND - AKRON (CANTON)": "Cleveland - Akron (Canton)",
  "COLORADO SPRINGS - PUEBLO": "Colorado Springs - Pueblo",
  "COLUMBIA - JEFFERSON CITY": "Columbia - Jefferson City",
  "COLUMBIA, SC": "Columbia, SC",
  "COLUMBUS - TUPELO - WEST POINT": "Columbus - Tupelo - West Point",
  "COLUMBUS, GA": "Columbus, GA",
  "COLUMBUS, OH": "Columbus, OH",
  "CORPUS CHRISTI": "Corpus Christi",
  "DALLAS - FT. WORTH": "Dallas - Fort Worth",
  "DAVENPORT - R. ISLAND - MOLINE": "Davenport - Rock Island - Moline",
  DAYTON: "Dayton",
  DENVER: "Denver",
  "DES MOINES - AMES": "Des Moines - Ames",
  DETROIT: "Detroit",
  DOTHAN: "Dothan",
  "DULUTH - SUPERIOR": "Duluth - Superior",
  "EL PASO (LAS CRUCES)": "El Paso (Las Cruces)",
  "ELMIRA (CORNING)": "Elmira (Corning)",
  ERIE: "Erie",
  EUGENE: "Eugene",
  EUREKA: "Eureka",
  EVANSVILLE: "Evansville",
  FAIRBANKS: "Fairbanks",
  "FARGO - VALLEY CITY": "Fargo - Valley City",
  "FLINT - SAGINAW - BAY CITY": "Flint - Saginaw - Bay City",
  "FRESNO - VISALIA": "Fresno - Visalia",
  "FT. MYERS - NAPLES": "Fort Myers - Naples",
  "FT. SMITH - FAY - SPRNGDL - RGRS": "Fort Smith - Fayetteville - Springdale - Rogers",
  "FT. WAYNE": "Fort Wayne",
  GAINESVILLE: "Gainesville",
  GLENDIVE: "Glendive",
  "GRAND JUNCTION - MONTROSE": "Grand Junction - Montrose",
  "GRAND RAPIDS - KALMZOO - B. CRK": "Grand Rapids - Kalmzoo - Battle Creek",
  "GREAT FALLS": "Great Falls",
  "GREEN BAY - APPLETON": "Green Bay - Appleton",
  "GREENSBORO - H. POINT - W. SALEM": "Greensboro - High Point - Winston Salem",
  "GREENVILLE - N. BERN - WASHNGTN": "Greenville - New Bern - Washington",
  "GREENVLL - SPART - ASHEVLL - AND": "Greenville - Sparta - Asheville - Anderson",
  "GREENWOOD - GREENVILLE": "Greenwood - Greenville",
  "HARLINGEN - WSLCO - BRNSVL - MCA": "Harlingen - Weslaco - Brownsville - McArthur",
  "HARRISBURG - LNCSTR - LEB - YORK": "Harrisburg - Lancaster - Lebanon - York",
  HARRISONBURG: "Harrisonburg",
  "HARTFORD & NEW HAVEN": "Hartford & New Haven",
  "HATTIESBURG - LAUREL": "Hattiesburg - Laurel",
  HELENA: "Helena",
  HONOLULU: "Honolulu",
  HOUSTON: "Houston",
  "HUNTSVILLE - DECATUR (FLOR)": "Huntsville - Decatur (Flor)",
  "IDAHO FALLS - POCATELLO": "Idaho Falls - Pocatello",
  INDIANAPOLIS: "Indianapolis",
  "JACKSON, MS": "Jackson, MS",
  "JACKSON, TN": "Jackson, TN",
  JACKSONVILLE: "Jacksonville",
  "JOHNSTOWN - ALTOONA": "Johnstown - Altoona",
  JONESBORO: "Jonesboro",
  "JOPLIN - PITTSBURG": "Joplin - Pittsburg",
  JUNEAU: "Juneau",
  "KANSAS CITY": "Kansas City",
  KNOXVILLE: "Knoxville",
  "LA CROSSE - EAU CLAIRE": "La Crosse - Eau Claire",
  "LAFAYETTE, IN": "Lafayette, IN",
  "LAFAYETTE, LA": "Lafayette, LA",
  "LAKE CHARLES": "Lake Charles",
  LANSING: "Lansing",
  LAREDO: "Laredo",
  "LAS VEGAS": "Las Vegas",
  LEXINGTON: "Lexington",
  LIMA: "Lima",
  "LINCOLN & HASTNGS-KRNY": "Lincoln & Hastings-Kearny",
  "LITTLE ROCK - PINE BLUFF": "Little Rock - Pine Bluff",
  "LOS ANGELES": "Los Angeles",
  LOUISVILLE: "Louisville",
  LUBBOCK: "Lubbock",
  MACON: "Macon",
  MADISON: "Madison",
  MANKATO: "Mankato",
  MARQUETTE: "Marquette",
  "MEDFORD - KLAMATH FALLS": "Medford - Klamath Falls",
  MEMPHIS: "Memphis",
  MERIDIAN: "Meridian",
  "MIAMI - FT. LAUDERDALE": "Miami - Fort Lauderdale",
  MILWAUKEE: "Milwaukee",
  "MINNEAPOLIS - ST. PAUL": "Minneapolis - St. Paul",
  "MINOT - BISMARCK - DICKINSON": "Minot - Bismarck - Dickinson",
  MISSOULA: "Missoula",
  "MOBILE - PENSACOLA (FT WALT)": "Mobile - Pensacola (Fort Walt)",
  "MONROE - EL DORADO": "Monroe - El Dorado",
  "MONTEREY - SALINAS": "Monterey - Salinas",
  "MONTGOMERY (SELMA)": "Montgomery (Selma)",
  "MYRTLE BEACH - FLORENCE": "Myrtle Beach - Florence",
  NASHVILLE: "Nashville",
  "NEW ORLEANS": "New Orleans",
  "NEW YORK": "New York",
  "NORFOLK - PORTSMTH - NEWPT NWS": "Norfolk - Portsmith - Newport News",
  "NORTH PLATTE": "North Platte",
  "ODESSA - MIDLAND": "Odessa - Midland",
  "OKLAHOMA CITY": "Oklahoma City",
  OMAHA: "Omaha",
  "ORLANDO - DAYTONA BCH - MELBRN": "Orlando - Daytona Beach - Melbourne",
  "OTTUMWA - KIRKSVILLE": "Ottumwa - Kirksville",
  "PADUCAH - CAPE GIRAR D - HARSBG": "Paducah - Cape Girardeau - Harrisburg",
  "PALM SPRINGS": "Palm Springs",
  "PANAMA CITY": "Panama City",
  PARKERSBURG: "Parkersburg",
  "PEORIA - BLOOMINGTON": "Peoria - Bloomington",
  PHILADELPHIA: "Philadelphia",
  "PHOENIX (PRESCOTT)": "Phoenix (Prescott)",
  PITTSBURGH: "Pittsburgh",
  "PORTLAND - AUBURN": "Portland - Auburn",
  "PORTLAND, OR": "Portland, OR",
  "PRESQUE ISLE": "Presque Isle",
  "PROVIDENCE - NEW BEDFORD": "Providence - New Bedford",
  "QUINCY - HANNIBAL - KEOKUK": "Quincy - Hannibal - Keokuk",
  "RALEIGH - DURHAM (FAYETVLLE)": "Raleigh - Durham (Fayetteville)",
  "RAPID CITY": "Rapid City",
  RENO: "Reno",
  "RICHMOND - PETERSBURG": "Richmond - Petersburg",
  "ROANOKE - LYNCHBURG": "Roanoke - Lynchburg",
  "ROCHESTER, NY": "Rochester, NY",
  "ROCHESTR - MASON CITY - AUSTIN": "Rochester - Mason City - Austin",
  ROCKFORD: "Rockford",
  "SACRAMNTO - STKTN - MODESTO": "Sacramento - Stockton - Modesto",
  SALISBURY: "Salisbury",
  "SALT LAKE CITY": "Salt Lake City",
  "SAN ANGELO": "San Angelo",
  "SAN ANTONIO": "San Antonio",
  "SAN DIEGO": "San Diego",
  "SAN FRANCISCO - OAK - SAN JOSE": "San Francisco - Oak - San Jose",
  "SANTABARBRA - SANMAR - SANLUOB": "Santa Barbara-Santa Maria-San Luis Obispo",
  SAVANNAH: "Savannah",
  "SEATTLE - TACOMA": "Seattle - Tacoma",
  "SHERMAN - ADA": "Sherman - Ada",
  SHREVEPORT: "Shreveport",
  "SIOUX CITY": "Sioux City",
  "SIOUX FALLS (MITCHELL)": "Sioux Falls (Mitchell)",
  "SOUTH BEND - ELKHART": "South Bend - Elkhart",
  SPOKANE: "Spokane",
  "SPRINGFIELD - HOLYOKE": "Springfield - Holyoke",
  "SPRINGFIELD, MO": "Springfield, MO",
  "ST. JOSEPH": "St. Joseph",
  "ST. LOUIS": "St. Louis",
  SYRACUSE: "Syracuse",
  "TALLAHASSEE - THOMASVILLE": "Tallahassee - Thomasville",
  "TAMPA - ST. PETE (SARASOTA)": "Tampa - St. Petersburg (Sarasota)",
  "TERRE HAUTE": "Terre Haute",
  TOLEDO: "Toledo",
  TOPEKA: "Topeka",
  "TRAVERSE CITY - CADILLAC": "Traverse City - Cadillac",
  "TRI - CITIES, TN - VA": "Tri - Cities, Tennessee–Virginia",
  "TUCSON (SIERRA VISTA)": "Tucson (Sierra Vista)",
  TULSA: "Tulsa",
  "TWIN FALLS": "Twin Falls",
  "TYLER - LONGVIEW (LFKN & NCGD)": "Tyler - Longview (Lufkin & Nacogdoches)",
  UTICA: "Utica",
  VICTORIA: "Victoria",
  "WACO - TEMPLE - BRYAN": "Waco - Temple - Bryan",
  "WASHINGTON, DC (HAGRSTWN)": "Washington, DC (Hagerstown)",
  WATERTOWN: "Watertown",
  "WAUSAU - RHINELANDER": "Wausau - Rhinelander",
  "WEST PALM BEACH - FT. PIERCE": "West Palm Beach - Fort Pierce",
  "WHEELING - STEUBENVILLE": "Wheeling - Steubenville",
  "WICHITA - HUTCHINSON PLUS": "Wichita - Hutchinson Plus",
  "WICHITA FALLS & LAWTON": "Wichita Falls & Lawton",
  "WILKES BARRE - SCRANTON": "Wilkes Barre - Scranton",
  WILMINGTON: "Wilmington",
  "YAKIMA - PASCO - RCHLND - KNNWCK": "Yakima - Pasco - Richland - Kennewick",
  YOUNGSTOWN: "Youngstown",
  "YUMA - EL CENTRO": "Yuma - El Centro",
  ZANESVILLE: "Zanesville",
} as const;
